import Image from "next/image";
import { memo, useContext, useState } from "react";
import fallbackImage from "shared/assets/images/selo.png";
import Widget from "shared/components/templates/Widget";
import GlobalContext from "shared/providers/context/GlobalContext";
import { Container, Wrapper, ImageWrapper } from "./styles";

const Warranty = () => {
  const { state } = useContext(GlobalContext);
  const [imageIsInvalid, setImageIsInvalid] = useState(false);

  const tenantData = state.tenancy;

  return (
    <>
      {tenantData?.settings?.site?.satisfactionGuaranteeActive === "1" && (
        <Wrapper>
          {window.innerHeight >= 830 && window.innerWidth >= 1315 ? (
            <Widget
              transparentDarkDisabled
              styleName="widget-margin-top gx-card-tabs gx-card-tabs-right gx-card-profile"
              title={tenantData?.settings?.site?.satisfactionGuaranteeTitle}
            >
              <Container>
                <ImageWrapper>
                  {tenantData?.settings?.site?.satisfactionGuaranteeImage ? (
                    <Image
                      src={
                        imageIsInvalid
                          ? fallbackImage
                          : tenantData?.settings?.site
                              ?.satisfactionGuaranteeImage
                      }
                      onError={() => setImageIsInvalid(true)}
                      alt="satisfactionGuaranteeImage"
                      width={90}
                      height={90}
                    />
                  ) : (
                    <Image
                      src={fallbackImage}
                      alt="satisfactionGuaranteeImage"
                      width={90}
                      height={90}
                    />
                  )}
                </ImageWrapper>

                {tenantData?.settings?.site
                  ?.satisfactionGuaranteeDescription && (
                  <span>
                    {
                      tenantData?.settings?.site
                        ?.satisfactionGuaranteeDescription
                    }
                  </span>
                )}
              </Container>
            </Widget>
          ) : (
            <Container>
              {tenantData?.settings?.site?.satisfactionGuaranteeImage && (
                <ImageWrapper>
                  <Image
                    src={
                      imageIsInvalid
                        ? fallbackImage
                        : tenantData?.settings?.site?.satisfactionGuaranteeImage
                    }
                    onError={() => setImageIsInvalid(true)}
                    alt="satisfactionGuaranteeImage"
                    width={90}
                    height={90}
                  />
                </ImageWrapper>
              )}

              {tenantData?.settings?.site?.satisfactionGuaranteeDescription && (
                <span>
                  {tenantData?.settings?.site?.satisfactionGuaranteeDescription}
                </span>
              )}
            </Container>
          )}
        </Wrapper>
      )}
    </>
  );
};

export default memo(Warranty);
